import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, NavLink } from "react-router-dom";
import Leaderboard from "./pages/Leaderboard";
import Matches from "./pages/Matches";
import MatchDetail from "./pages/MatchDetail";
import PlayerProfile from "./pages/PlayerProfile";
import Heatmap from "./pages/Heatmap";
import Compare from "./pages/Compare";
import Seasons from "./pages/Seasons";
import SeasonDetail from "./pages/SeasonDetail";
import Admin from "./pages/Admin";
import "./index.css";

function Nav() {
  const linkStyle = ({ isActive }) => ({
    color: isActive ? "#f0a500" : "#9ca3af",
    textDecoration: "none",
    fontWeight: isActive ? "600" : "400",
    padding: "0.5rem 1rem",
    borderBottom: isActive ? "2px solid #f0a500" : "2px solid transparent",
  });
  return (
    <nav style={{ background: "#1a1d26", borderBottom: "1px solid #2d3148", display: "flex", alignItems: "center", padding: "0 1.5rem", gap: "0.5rem" }}>
      <span style={{ color: "#f0a500", fontWeight: "700", fontSize: "1.1rem", marginRight: "1.5rem", padding: "1rem 0" }}>
        🎮 CS2 Stats
      </span>
      <NavLink to="/" end style={linkStyle}>Leaderboard</NavLink>
      <NavLink to="/matches" style={linkStyle}>Matches</NavLink>
      <NavLink to="/seasons" style={linkStyle}>Seasons</NavLink>
      <NavLink to="/admin" style={linkStyle}>Admin</NavLink>
      <NavLink to="/compare" style={linkStyle}>Compare</NavLink>
      <NavLink to="/heatmap" style={linkStyle}>Heatmap</NavLink>
    </nav>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Nav />
      <div style={{ maxWidth: "1100px", margin: "0 auto", padding: "2rem 1rem" }}>
        <Routes>
          <Route path="/" element={<Leaderboard />} />
          <Route path="/matches" element={<Matches />} />
          <Route path="/matches/:id" element={<MatchDetail />} />
          <Route path="/matches/:matchId/heatmap" element={<Heatmap />} />
          <Route path="/players/:steamId" element={<PlayerProfile />} />
          <Route path="/compare" element={<Compare />} />
          <Route path="/heatmap" element={<Heatmap />} />
          <Route path="/seasons" element={<Seasons />} />
          <Route path="/seasons/:id" element={<SeasonDetail />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

ReactDOM.createRoot(document.getElementById("root")).render(<App />);
